(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_griptape-options"] && !Shopify.designMode) return;
  try {
    function checkTheBox(item) {
  item.checked = true;
  item.setAttribute("checked", "true");
  item.closest('label').classList.add('checked');
}
function unCheckTheBox(item) {
  item.checked = false;
  item.removeAttribute("checked");
  item.closest('label').classList.remove('checked');
}

function gripInit(gripNone, gripNoneRadio, griptapeRadios) {
    checkTheBox(griptapeRadios[0]);
    gripNone.addEventListener("click", function(e) {
      e.preventDefault();
      if (document.getElementById('multi_grip')) {
        document.getElementById('multi_grip').setAttribute("name", "");
      }
      checkTheBox(gripNoneRadio);
      for (var i2 = 0; i2 < griptapeRadios.length; i2++) {
        unCheckTheBox(griptapeRadios[i2]);
      }
    });
    for (var i = 0; i < griptapeRadios.length; i++) {
      griptapeRadios[i].addEventListener("change", function(e) {
        unCheckTheBox(gripNoneRadio);
        if (document.getElementById('multi_grip')) {
          document.getElementById('multi_grip').setAttribute("name", "items[1]quantity");
        }
      })
    }
}
function applyInit(applyNone, applyNoneRadio, applyRadios) {
    checkTheBox(applyNoneRadio);
    applyNone.addEventListener("click", function(e) {
      e.preventDefault();
      checkTheBox(applyNoneRadio);
      for (var i2 = 0; i2 < applyRadios.length; i2++) {
          unCheckTheBox(applyRadios[i2]);
      }
    });
    for (var i = 0; i < applyRadios.length; i++) {
      applyRadios[i].addEventListener("change", function(e) {
        unCheckTheBox(applyNoneRadio);
      })
    }
}

var gripNone = document.getElementById("grip_none");
var gripNoneRadio = document.getElementById("grip_none_radio");
var griptapeRadios = document.getElementsByName("items[1]id");
gripInit(gripNone, gripNoneRadio, griptapeRadios);

var applyNone = document.getElementById("apply_none");
var applyNoneRadio = document.getElementById("apply_none_radio");
var applyRadios = document.getElementsByName("items[2]id");
applyInit(applyNone, applyNoneRadio, applyRadios);
  } catch(e) { console.error(e); }
})();

})();
